import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class PlacesService {
    constructor() {}

    // Create the marker from the places response
    placesToMarkers(places: any[]): any[] {
        let markers = [];

        places.forEach((place: any) => {
            let placeMarker = {
                placeId: place.place_id,
                label: place.name,
                position: {
                    lat: Number(place.geometry.location.lat()),
                    lng: Number(place.geometry.location.lng()),
                },
            };

            markers = [...markers, placeMarker];
        });

        return markers;

        // return places.map((place) => ({
        //   id: place.id,
        //   name: place.name,
        //   position: {
        //     lat: place.geometry.location.lat(),
        //     lng: place.geometry.location.lng(),
        //   },
        //   icon: place.icon || 'assets/images/marker.png',
        //   types: place.types || [],
        // }));
    }
}
